import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import logo from '../assets/logo.svg';
import { NAV_LINKS, COMPANY_INFO } from '../constants';
import { useScrollDetection } from '../hooks';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isScrolled = useScrollDetection(20);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <nav className={`fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md border-b border-gray-100' : 'bg-blue-800'} h-20`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="flex items-center justify-between h-full">
          {/* Logo y marca */}
          <Link 
            to="/" 
            className="flex items-center space-x-3 group"
            aria-label="Ir al inicio"
          >
            <img 
              src={logo} 
              alt="Logo Geriatría Serena" 
              className="h-[7rem] w-[7rem]  transition-transform duration-300 group-hover:scale-105" 
            />
            <span className={`text-xl font-bold tracking-tight ${isScrolled ? 'text-blue-800' : 'text-white'} transition-colors duration-300`}>
              Geriatría Serena
            </span>
          </Link>

          {/* Menú desktop */}
          <div className="hidden lg:flex items-center space-x-8 h-full">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative h-full flex items-center px-2 font-medium transition-colors ${
                  isScrolled 
                    ? 'text-gray-700 hover:text-blue-800' 
                    : 'text-white hover:text-blue-100'
                } ${
                  location.pathname === link.path 
                    ? isScrolled 
                      ? 'text-blue-800 border-b-2 border-blue-800' 
                      : 'text-white border-b-2 border-white'
                    : ''
                }`}
              >
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-800 transition-all duration-300 group-hover:w-full"></span>
              </Link>
            ))}
            <a
              href={`https://wa.me/${COMPANY_INFO.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className={`ml-4 px-6 py-2.5 rounded-full font-medium transition-all ${
                isScrolled 
                  ? 'bg-blue-800 text-white hover:bg-blue-900 shadow-lg' 
                  : 'bg-white text-blue-800 hover:bg-gray-50 shadow-lg'
              }`}
            >
              <span className="hidden sm:inline">Cotizar servicio</span>
              <span className="sm:hidden">WhatsApp</span>
            </a>
          </div>

          {/* Botón móvil */}
          <button
            className="lg:hidden p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            onClick={() => setIsOpen(!isOpen)}
            aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={isOpen}
          >
            {isOpen ? (
              <FiX className={`h-7 w-7 ${isScrolled ? 'text-blue-800' : 'text-white'} transition-colors`} />
            ) : (
              <FiMenu className={`h-7 w-7 ${isScrolled ? 'text-blue-800' : 'text-white'} transition-colors`} />
            )}
          </button>
        </div>
      </div>

{/* Menú móvil*/}
<div className={`lg:hidden fixed inset-0 z-40 transition-all duration-300 ease-in-out ${isOpen ? 'visible' : 'invisible'}`}>
        {isOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-30" 
            onClick={() => setIsOpen(false)}
            aria-hidden="true"
          />
        )}
        
        <div 
          className={`absolute right-0 top-20 w-full max-w-xs bg-white shadow-2xl transform ${
            isOpen ? 'translate-x-0' : 'translate-x-full'
          } transition-transform duration-300 h-[calc(100vh-5rem)] flex flex-col`}
        >
          <div className="flex flex-col p-4 h-full overflow-y-auto">
            {/* Sección de enlaces con scroll */}
            <div className="flex-1 overflow-y-auto">
              {NAV_LINKS.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="block px-4 py-3 text-gray-800 hover:bg-blue-50 rounded-lg transition-colors font-medium"
                  onClick={() => setIsOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
            </div>
            
            {/* Botones fijos en la parte inferior */}
            <div className="border-t pt-4 space-y-2 mt-auto"> 
              <a
                href={`tel:${COMPANY_INFO.phone}`}
                className="block px-4 py-3 bg-blue-100 text-blue-800 rounded-lg text-center font-semibold"
              >
                📞 Llámanos
              </a>
              <a
                href={`https://wa.me/${COMPANY_INFO.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="block px-4 py-3 bg-blue-800 text-white rounded-lg text-center font-semibold hover:bg-blue-900 transition-colors"
              >
                💬 WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;